import { useSelector } from 'react-redux';
import { loginModule } from '../../pages/LoginPage/LoginDucks';

const useUserInfo = () => {
  return { ...useSelector(state => state[loginModule].user) };
};

export default useUserInfo;
